<template>
<div class="activity-item">
<!--
{{activity.id}}
{{activity.clientName}} {{activity.name}} {{$parent.strip(activity.description)}}
{{activity.assignedTo.nameFirst}}
{{activity.assignedTo.nameLast}}
{{$parent.convertunixtodatetime(activity.createdAt)}}
{{activity.status.name}}
{{activity.activityQuality.name}}-->
	
    
    <article class="message">
                <div class="message-header">
                   {{activity.clientName}} {{activity.name}}
                </div>
                
                <div class="message-body">
                <p><b>Created At: </b> {{$parent.convertunixtodatetime(activity.createdAt)}}</p>
                 <p> <b>Priority:</b> {{activity.priority}}, <b>Status:</b> {{activity.status.name}}, <b>Quality:</b> {{activity.activityQuality.name}} </p>
                <p> <b>Description:</b>  {{$parent.strip(activity.description)}} </p>
                  
                     <div v-if="loading">Loading...</div>
                     <div v-if="!expanded"><br><button class="button is-dark" @click="getAdditionalInformation" style="margin-top:-13px">Expand</button></div>
                    <div v-if="expanded && !loading">
                    
                      <p> <b>Assigned To:</b> {{activity.assignedTo.nameFirst}} {{activity.assignedTo.nameLast}} </p>
                     <p> <b>Created By:</b> {{activity.createdBy.nameFirst}} {{activity.createdBy.nameLast}} </p>
                    
                    
                    <p><b>Comments:</b></p>
                    <p v-for="comment in comments">
                    {{$parent.convertunixtodatetime(comment.createDate)}} {{comment.user.nameFirst}} {{comment.user.nameLast}}: {{$parent.strip(comment.comment)}}
                    </p>
                
                    <p><b>Root Causes:</b> </p>
                    <p v-for="cause in rootCauses">
                    {{$parent.convertunixtodatetime(cause.modifiedAt)}} {{cause.rootCause}}
                    </p>
            
             
                   <p> <b>Actions Taken:</b> </p> 
                     <p v-for="action in actionsTaken">
                    {{$parent.convertunixtodatetime(action.modifiedAt)}} {{action.action}}
                    </p>
                    </div>
                
                   
                </div>
        </article>
  </div>  
 
    
</template>

<script>

import axios from 'axios'

export default {
  name: 'Activity',
 	props: ['activity'],
	data() {
		return {
			loading: false,
            expanded: false,
            comments: [],
            rootCauses: [],
            actionsTaken: [],
		}
	},
	methods: {
    async getAdditionalInformation(){
    
        this.loading=true;
        this.expanded=true;
        let urlactions = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release" + this.activity.actionsTakenReference;
         let urlcomments = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release" + this.activity.commentsReference;                  
         let urlrootcauses = this.$store.getters.proxyurl + "https://eadvantage.siemens.com/remote/release" + this.activity.rootCausesReference;                  
                      let urlArray = [urlactions, urlcomments, urlrootcauses];              
                    let promiseArray = urlArray.map(url => axios.get(url, {headers: {'Accept': 'application/json','Content-Type': 'x-www-form-urlencoded',},auth: {username:this.$store.getters.navigatorUsername,password: this.$store.getters.navigatorPassword}}));
                           //do all get request at same time for efficiency
                            return await axios.all(promiseArray)
                            .then(async (responseArray) => {
                            console.log(responseArray);
                        this.comments = responseArray[1].data;
                        this.rootCauses = responseArray[2].data;
                        this.actionsTaken = responseArray[0].data;   
                        this.loading=false;
                        return console.log("Retrieved Additional Information");
                        }).catch((error) => {
                        console.log(error);
         this.loading=false;
       
    });
                        
                        
                        }
                        
    
    
    }
    
    
        }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>


